import React from "react";
import { Row, Col, Form, Button, Icon } from "antd";
import { withApollo } from "react-apollo";
import { compose } from "recompose";
import { withGlobal } from "../../../../component-global";
import { InputComponentWithBorder } from "../../../../components/FormFields";
import { ContainerGlobal } from "../../../../components/Form/SearchContainer";

class AffiliatesAgencySearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const filter = {};
      if (values.nameAffiliate) filter.nameAffiliate = values.nameAffiliate;
      this.props.searchAgency(filter);
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loadingBtnSearch } = this.props;

    return (
      <ContainerGlobal>
        <Row gutter={16}>
          <Form onSubmit={this.handleSubmit}>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <InputComponentWithBorder
                getFieldDecorator={getFieldDecorator}
                placeholder="Buscar "
                decodator="nameAffiliate"
                suffix={<Icon type="search" />}
                htmlType="submit"
              />
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}></Col>
            {this.props.permissionsView?.create && (
              <>
                <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                  <Button
                    type="primary"
                    ghost
                    style={{
                      width: "100%",
                      fontFamily: "Gilroy, sans-serif",
                      fontWeight: "600",
                      fontSize: "14px",
                      lineHeight: "16px",
                      border: "1px solid #307FE2",
                      color: "#307FE2",
                    }}
                    loading={loadingBtnSearch}
                    size="large"
                    onClick={this.props.openCsvModal}
                  >
                    Crear afiliados por CSV
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                  <Button
                    type="primary"
                    ghost
                    style={{
                      width: "100%",
                      fontFamily: "Gilroy, sans-serif",
                      fontWeight: "600",
                      fontSize: "14px",
                      lineHeight: "16px",
                      border: "1px solid #307FE2",
                      color: "#307FE2",
                    }}
                    loading={loadingBtnSearch}
                    size="large"
                    onClick={this.props.openDrawer}
                  >
                    Nuevo afiliado +
                  </Button>
                </Col>
              </>
            )}
          </Form>
        </Row>
      </ContainerGlobal>
    );
  }
}

const WrappedAffiliatesAgencySearchBar = withGlobal(AffiliatesAgencySearchBar);

const AffiliatesAgencySearchBarForm = Form.create()(
  WrappedAffiliatesAgencySearchBar
);

export default compose(withApollo)(AffiliatesAgencySearchBarForm);
